import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  UpdateStakeholderMutation as UpdateStakeholderMutationType,
  UpdateStakeholderMutationVariables,
} from "./__generated__/UpdateStakeholderMutation";

const UpdateStakeholderMutation = loader("./UpdateStakeholderMutation.gql");

type UpdateStakeholderMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: UpdateStakeholderMutationType) => void;
}) => ReactElement;

export const UpdateStakeholderMutationProvider: UpdateStakeholderMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<UpdateStakeholderMutationType, UpdateStakeholderMutationVariables>(
    UpdateStakeholderMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
